import React from 'react';
import _ from 'lodash';
import { renderToString } from 'react-dom/server';
import StyledPopper from 'components/StyledPopper';
import AreaChartV2 from 'components/highcharts/AreaChartV2';
import TooltipWrapper from 'components/Tooltips/TooltipWrapper';
import { Flex, Margin } from 'components/base/layout-components';
import TooltipTitle from 'components/Tooltips/TooltipTitle';
import IconedValueLine from 'components/IconedValueLine';
import Reviews from 'images/icons/reviews.svg';
import BoldedValue from 'components/BoldedValue';

const getAvg = data => {
  const nonNullData = data.filter(val => val !== null);
  return _.round(_.sum(nonNullData) / nonNullData.length || 0, 2);
};
const Tooltip = ({ title, data, descriptor }) => {
  return (
    <TooltipWrapper title={title}>
      <Flex direction='column' padding='small'>
        {data.map((value, i) => (
          <BoldedValue
            key={value + i.toString()}
            value={{ size: 'x-large', text: value || 0 }}
            description={{ size: 'small', text: descriptor[i] }}
          />
        ))}
      </Flex>
    </TooltipWrapper>
  );
};
const RetrospectTrendPopper = ({
  anchorEl,
  data = {},
  onClose,
  texts = {},
  icon = Reviews
}) => {
  const { title, avg: avgText, tooltip: tooltipTexts } = texts;
  if (!data.x || !data.y) {
    return null;
  }
  const dataX = data.x || {};
  return (
    <StyledPopper
      anchorEl={anchorEl}
      onClose={onClose}
      transition
      placement={'bottom-end'}
      style={{ zIndex: 1000 }}
      title={title}
      width='48rem'
    >
      <Flex direction='column' height='100%'>
        <Margin b='small' l='small'>
          <IconedValueLine
            value={getAvg(data.y.map(y => y[0]))}
            descriptor={avgText}
            icon={icon}
          />
        </Margin>
        <AreaChartV2
          chartOptionsProp={{
            xAxis: {
              categories: Object.keys(data.x),
              labels: {
                formatter() {
                  const iteration = dataX[this.value];
                  return _.get(iteration, 'name', '');
                }
              },
              reversed: true
            },
            yAxis: {
              title: {
                text: ''
              },
              min: 0,
              tickAmount: 6
            },
            tooltip: {
              useHTML: true,
              backgroundColor: 'none',
              borderWidth: 0,
              shadow: false,
              padding: 0,
              formatter() {
                const iteration = dataX[this.x] || {};
                const tooltipData = data.y[iteration.index];
                return renderToString(
                  <Tooltip
                    descriptor={tooltipTexts}
                    data={tooltipData}
                    title={
                      <TooltipTitle
                        text={iteration.dates}
                        boldText={iteration.name}
                        size='medium'
                      />
                    }
                  />
                );
              }
            },
            series: [{ data: data.y.map(y => y[0]) }]
          }}
        />
      </Flex>
    </StyledPopper>
  );
};

export default RetrospectTrendPopper;
